<template>
  <div>
    <div class="custom-cursor" ref="cursor"></div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "CustomCursor",
  data() {
    return {
      cursorPos: { x: -100, y: -100 },
      targetPos: { x: -100, y: -100 },
      rafId: null,
    };
  },
  mounted() {
    this.cursor = this.$refs.cursor;
    this.setupEventListeners();
    this.startCursorAnimation();
  },
  beforeUnmount() {
    this.cleanupEventListeners();
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
    }
  },
  methods: {
    setupEventListeners() {
      document.addEventListener("mousemove", this.handleMouseMove);
      document.addEventListener("mouseleave", () => {
        this.cursor.style.opacity = "0";
      });
      document.addEventListener("mouseenter", () => {
        this.cursor.style.opacity = "1";
      });

      // Track interactive elements
      this.attachInteractiveHandlers();

      // Observer for DOM changes
      const observer = new MutationObserver(() => {
        this.attachInteractiveHandlers();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    },

    cleanupEventListeners() {
      document.removeEventListener("mousemove", this.handleMouseMove);
    },

    attachInteractiveHandlers() {
      const elements = document.querySelectorAll(
        'a, button, input, select, textarea, [role="button"], .interactive, .link'
      );

      elements.forEach((el) => {
        if (!el.dataset.cursorHandlersAttached) {
          el.addEventListener("mouseenter", this.handleElementHover);
          el.addEventListener("mouseleave", this.handleElementLeave);
          el.dataset.cursorHandlersAttached = "true";
        }
      });
    },

    handleMouseMove(e) {
      this.targetPos = {
        x: e.clientX,
        y: e.clientY,
      };
    },

    updateCursorPosition() {
      // Smooth cursor movement with delay
      this.cursorPos.x += (this.targetPos.x - this.cursorPos.x) * 0.15;
      this.cursorPos.y += (this.targetPos.y - this.cursorPos.y) * 0.15;

      this.cursor.style.transform = `translate(${this.cursorPos.x}px, ${this.cursorPos.y}px)`;

      this.rafId = requestAnimationFrame(this.updateCursorPosition);
    },

    handleElementHover() {
      this.cursor.classList.add("hover");
    },

    handleElementLeave() {
      this.cursor.classList.remove("hover");
    },

    startCursorAnimation() {
      this.cursorPos = { x: this.targetPos.x, y: this.targetPos.y };
      this.updateCursorPosition();
    },
  },
};
</script>

<style lang="scss">
* {
  cursor: none !important;
}

.custom-cursor {
  position: fixed;
  top: 0;
  left: 0;
  width: 12px;
  height: 12px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  pointer-events: none;
  z-index: 10000;
  transform: translate(-50%, -50%);
  transition: width 0.2s ease, height 0.2s ease, background-color 0.2s ease;

  &.hover {
    width: 18px;
    height: 18px;
    background: #3d73ff;
  }
}

@media (prefers-color-scheme: dark) {
  .custom-cursor {
    background: rgba(200, 200, 200, 0.9);
  }
}

@media (max-width: 768px) {
  * {
    cursor: auto !important;
  }

  .custom-cursor {
    display: none;
  }
}
</style>
